
import Vue, { PropType } from 'vue';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import Modal from '@/components/layout/modal.vue';
import BannerStandOrder from '@/store/modules/banner-stand-orders/banner-stand-order';

export default Vue.extend({
  name: 'BannerStandOrderModal',
  components: {
    Modal,
  },
  props: {
    order: {
      type: Object as PropType<BannerStandOrder>,
      required: true,
    },
  },
  data() {
    return {
      isImagePreviewOpen: false,
      previewImage: null as { thumbnail: string; preview: string; s3: string } | null,
    };
  },
  methods: {
    formatDate(dateString: string): string {
      try {
        return format(parseISO(dateString), 'd MMMM yyyy');
      } catch {
        return dateString;
      }
    },
    openImagePreview(image: { thumbnail: string; preview: string; s3: string }) {
      this.previewImage = image;
      this.isImagePreviewOpen = true;
    },
    closeImagePreview() {
      this.isImagePreviewOpen = false;
      this.previewImage = null;
    },
  },
});
